

























import { SXSurvey, SXAnswer } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";
import app from "@/app";

@Component
export default class WSurveyAnswers extends BaseComponent {
	@Prop({ type: SXSurvey, required: true })
	survey!: SXSurvey;

	loading = false;
	answersTotalCount = 0;

	get answersTotal() {
		return this.answersTotalCount || this.answers.length;
	}

	get answersCounterMessage() {
		let x = this;
		return x.i18n(
			"SX_LANG_ANSWERS_COUNT",
			{ count: x.answersTotal },
			function() {
				return x.answersTotal > 1 ? 1 : 0;
			}
		);
	}

	get answers() {
		let x = this;
		return app.services.answers
			.select(undefined, function(item) {
				return item.id && item.survey_id === x.survey.id;
			})
			.sort(function(a, b) {
				return b.create_time - a.create_time;
			});
	}

	answerUser(answer: SXAnswer) {
		return app.services.users.identify(answer.user_id);
	}

	created() {
		let x = this,
			always = () => (x.loading = false);
		x.loading = true;

		app.services.answers.getAll(
			{
				filters: {
					[SXAnswer.COL_SURVEY_ID]: x.survey.id
				},
				relations: "user"
			},
			function(response) {
				always();
				x.answersTotalCount = response.data.total || 0;
				app.services.users.addItemsToList(
					response.data.relations!.user
				);
			},
			always,
			false
		);
	}
}
